import { CustomRoute } from "@/interfaces";
import { Bell, FileText, User } from "lucide-react";
import React from "react";
import { Navigate } from "react-router";

const PowerBiPage = React.lazy(() => import("@/modules/SuperAdmin/PowerBi"));
const PowerBiViewer = React.lazy(() => import("@/modules/SuperAdmin/PowerBi/PowerBiViewer"));
const EditProfile = React.lazy(() => import("../modules/Profile/EditProfile"));
const AllNotifications = React.lazy(() => import("../modules/Notifications/AllNotifications"));

// PowerBiUser is restricted to view-only access to their own assigned Power BI dashboard(s),
// plus the shared Profile/Notifications utility routes every logged-in role gets. Unlike
// PowerBiAdmin, this role has no create/edit/delete capability — PowerBiPage already renders a
// view-only list (no Add button, no management columns) for any role other than Super/PowerBiAdmin,
// so no separate page component is needed here.
const powerBiUserRoutes: CustomRoute[] = [
  {
    // Every role router needs an explicit "/" landing route — post-login redirects target "/",
    // and the catch-all otherwise bounces "/" back to itself, leaving a blank page.
    path: "/",
    id: "PowerBiUser",
    // Lands on /powerbi so the Power BI menu shows as selected
    element: <Navigate to="/powerbi" replace />,
    menuName: "Power BI",
    hideInMenu: true,
    highlightOn: ["powerbi"],
  },
  {
    path: "/powerbi",
    id: "PowerBiUser",
    element: <PowerBiPage />,
    menuName: "Power BI",
    icon: FileText,
    highlightOn: ["powerbi"],
  },
  {
    path: "/powerbi/view/:id",
    id: "PowerBiUser",
    element: <PowerBiViewer />,
    menuName: "Power BI Viewer",
    hideInMenu: true,
    highlightOn: ["powerbi"],
  },
  {
    path: "/notifications",
    id: "PowerBiUser",
    element: <AllNotifications />,
    menuName: "Notifications",
    icon: Bell,
    highlightOn: ["notifications"],
  },
  {
    path: "/profile",
    id: "PowerBiUser",
    element: <EditProfile />,
    menuName: "Profile",
    icon: User,
    highlightOn: ["profile"],
  },
];

export default powerBiUserRoutes;
